import type {
  BalanceDTO,
  CheckoutSessionInput,
  PlanDTO,
  SubscriptionDTO,
  TopUpInput,
} from '@bruno/shared';
import { api } from './client';

export interface SubscriptionWithWebsite extends SubscriptionDTO {
  websiteName: string;
  websiteDomain: string;
}

export const listPlans = () => api<{ plans: PlanDTO[] }>('/v1/billing/plans');

export const getBalance = () => api<BalanceDTO>('/v1/billing/balance');

export const listMySubscriptions = () =>
  api<{ subscriptions: SubscriptionWithWebsite[] }>('/v1/billing/subscriptions');

export const getWebsiteSubscription = (websiteId: string) =>
  api<{ subscription: SubscriptionDTO | null; plan: PlanDTO | null }>(
    `/v1/billing/subscriptions/website/${websiteId}`,
  );

export const startSubscriptionCheckout = (body: CheckoutSessionInput) =>
  api<{ url: string }>('/v1/billing/checkout', { method: 'POST', body });

export const startTopUp = (body: TopUpInput) =>
  api<{ url: string }>('/v1/billing/topup', { method: 'POST', body });

export const openBillingPortal = () =>
  api<{ url: string }>('/v1/billing/portal', { method: 'POST' });

export const listBalanceTransactions = () =>
  api<{
    transactions: Array<{ id: string; deltaCents: number; reason: string; createdAt: string }>;
  }>('/v1/billing/transactions');

export interface WebsiteUsage {
  websiteId: string;
  websiteName: string;
  websiteDomain: string;
  plan: { name: string; includedTokens: number; maxConcurrentUsers: number } | null;
  subscription: {
    status: string;
    usageTokens: number;
    currentPeriodEnd: string | null;
  } | null;
  totals: {
    conversations: number;
    messages: number;
    tokens: number;
    costCents: number;
  };
}

export const getUsage = () =>
  api<{ websites: WebsiteUsage[] }>('/v1/billing/usage');
